import { BehaviorSubject } from 'rxjs'
import { Configuration, Person, PersonApi } from '../api'
import { appState } from './App.state'

interface AuthState {
    user$: BehaviorSubject<Person | null>
    apiKey$: BehaviorSubject<string | undefined>
    igvNumber$: BehaviorSubject<number | null>
    apicfg: () => Configuration
    login: (igvKennung: number, password: string) => Promise<boolean>
    logout: () => void
    tryAutoLogin: () => void
}

export const authState: AuthState = {
    user$: new BehaviorSubject<Person | null>(null),
    apiKey$: new BehaviorSubject<string | undefined>(localStorage.getItem('apiKey') ?? undefined),
    igvNumber$: new BehaviorSubject<number | null>(
        localStorage.getItem('igvNumber') ? parseInt(localStorage.getItem('igvNumber')!, 10) : null
    ),
    apicfg: () =>
        new Configuration({

            basePath: 'https://on-bc.2-service.de',

/*
            basePath: 'https://on-bc.2-service.de',
            basePath: 'https://pfae-bc.2-service.de',
            basePath: 'http://localhost:5000',
            basePath: 'http://pfae-bc-test.2-service.de',
*/
            apiKey: authState.apiKey$.value
        }),
    login: async (igvKennung: number, password: string) => {
        try {
            const user = await new PersonApi(authState.apicfg()).apiPersonLoginIGVKennungPasswordGet({ iGVKennung: igvKennung, password })
            authState.apiKey$.next(user?.apiKey ?? undefined)
            authState.igvNumber$.next(igvKennung)
            localStorage.setItem('apiKey', user?.apiKey ?? '')
            localStorage.setItem('igvNumber', String(igvKennung))
            localStorage.setItem('user', JSON.stringify(user))
            authState.user$.next(user)
            window.location.hash = '#/home'
            return true
        } catch (e) {
            appState.addToast('Login fehlgeschlagen!', 'error')
            return false
        }
    },
    logout: () => {
        authState.user$.next(null)
        authState.igvNumber$.next(null)
        localStorage.removeItem('apiKey')
        localStorage.removeItem('igvNumber')
        localStorage.removeItem('user')
    },
    tryAutoLogin: () => {
        const apiKey = localStorage.getItem('apiKey')
        const userJson = localStorage.getItem('user')
        const igvNumber = localStorage.getItem('igvNumber')
        if (apiKey && userJson) {
            authState.apiKey$.next(apiKey)
            authState.user$.next(JSON.parse(userJson))
            authState.igvNumber$.next(igvNumber ? parseInt(igvNumber, 10) : null)
        }
    }
}
